module.exports = __webpack_public_path__ + "media/dashboard/assets/icons/ic_forward-c1868e2ac5ef81e0b617eec87c8049ed.svg";